export default __webpack_public_path__ + "static/mario-bitmoji-ee7276c4a809c3eef13ed8f29f94ae00.png";